import { Component, OnInit } from '@angular/core';
import $ from 'jquery'

@Component({
  selector: 'ppa-header-publico',
  templateUrl: './header-publico.component.html',
  styleUrls: ['./header-publico.component.css']
})
export class HeaderPublicoComponent implements OnInit {
  usuarioLogado = false;

  constructor() { }

  ngOnInit() {
    // $('ul>li>a').click(function () {
    //   $('html,body').animate({ 
    //     scrollTop: 300
    //   }, 'slow');
    // });
  }

}
